'use client';
import IconInfo from '@/assets/icons/cart/Info.svg';
import IconBg from '@/assets/icons/icon-white-bg.svg';
import IconLogo from '@/assets/icons/radius_qora_logo.svg';
import IconArrowLeft from '@/assets/icons/order/icon-arrow-left.svg';

import { CustomCitiesSelect, CustomDefaultAccordion } from '@/components';
import {
  DraftOrderCompleteMutation,
  ExternalPartnerNameEnum,
  PaymentTabEnum,
  useDraftOrderCompleteMutation,
  useDraftOrderDeleteMutation,
  useDraftOrderUpdateMutation,
  useOrderClickPaymentUrlMutation,
  useOrderFreedomPayInitMutation,
  useOrderUzumNasiyaCheckStatusMutation,
  useUserOrdersQuery,
  useWarehousesQuery,
} from '@/graphql';

import { Address } from '@/graphql/graphql';
import convertToReadable from '@/helpers/convertToReadable';
import { useRouter } from '@/i18n/navigation';
import useUserStore from '@/zustand/useUser';
import { FetchResult } from '@apollo/client';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Skeleton from 'react-loading-skeleton';
import { toast } from 'react-toastify';
import { useWindowSize } from 'react-use';
import { Accordion, Button } from 'rsuite';
import DeliverySection from './components/delivery';
import MobileHeader from './components/mobile-header';
import Payment from './components/payments';
import PickupSection from './components/pickup';
import YandexDeliverySection from './components/yandexDelivery';
import styles from './order.module.scss';
import { useCityStore } from '@/zustand/cityStore';
import DefaultProductPlaceholder from '@/assets/images/Yellow.png';
type Props = {};

const OrderPageContent = (props: Props) => {
  const user = useUserStore((user: any) => user?.user);
  const [searchTerm, setSearchTerm] = useState('');
  const { cityValue } = useCityStore();
  const { data: orderData, loading } = useUserOrdersQuery({
    variables: {
      userId: user ? user?.id : '',
    },
    skip: !user,
  });
  const { data: warehousesData, loading: warehousesLoading } =
    useWarehousesQuery({
      variables: {
        first: 50,
        filter: {
          availableForOrder: orderData?.userDraftOrders?.[0]?.id,
          city: cityValue,
          search: searchTerm,
        },
      },
      skip: !orderData?.userDraftOrders?.[0]?.id,
    });
  const [updateDraftOrder, { loading: updateLoading }] =
    useDraftOrderUpdateMutation();
  const [completeDraftOrder] = useDraftOrderCompleteMutation();
  const [orderFreedom] = useOrderFreedomPayInitMutation();
  const [orderClick] = useOrderClickPaymentUrlMutation();
  const [uzumNasiyaCheckStatus] = useOrderUzumNasiyaCheckStatusMutation();

  const [orderDelete] = useDraftOrderDeleteMutation();
  const order = orderData?.userDraftOrders?.[0];
  const [orderCompleteRes, setOrderCompleteRes] =
    useState<FetchResult<DraftOrderCompleteMutation> | null>(null);
  const [isOrderComplete, setIsOrderComplete] = useState(false);
  const [shippingId, setShippingId] = useState<string | null>(null);
  const [collectionPointId, setCollectionPointId] = useState<string | null>(
    null
  );
  const windowSize = useWindowSize();
  const [activePayment, setActivePayment] = useState(false);
  const [openProducts, setOpenProducts] = useState(false);
  const [openProducts2, setOpenProducts2] = useState(false);
  const [deliveryPrice, setDeliveryPrice] = useState<number | null>(null);
  const [hasCities, setHasCities] = useState(false);
  const [applicationId, setApplicationId] = useState<string | null>(null);
  const [checked, setChecked] = useState(true);
  const [state, setState] = useState(true);
  const [city, setCity] = useState<string>('');
  const [uzumWebViewUrl, setUzumWebViewUrl] = useState<string | null>(null);
  const [uzumBuyerId, setUzumBuyerId] = useState<number | null>(null);
  const [shippingDate, setShippingDate] = useState<string | null>(null);
  const [shippingStartTime, setShippingStartTime] = useState('');
  const [shippingEndTime, setShippingEndTime] = useState('');
  const [paymentMethod, setPaymentMethod] = useState<PaymentTabEnum>(
    PaymentTabEnum.FREEDOM_PAY
  );
  const [installmentName, setInstallmentName] = useState<
    ExternalPartnerNameEnum | string
  >(ExternalPartnerNameEnum.UZUM);
  const [installmentPeriod, setInstallmentPeriod] = useState<number | null>(
    null
  );
  const [tab, setTab] = useState(1);
  const isPickupDisabled = warehousesData?.warehouses?.edges.length === 0;
  // const isLoggedIn = Boolean(user?.id);
  const [deliveryIsYandex, setDeliveryIsYandex] = useState(false);
  const {
    handleSubmit,
    control,
    reset: resetForm,
    formState: { errors },
  } = useForm({}) as any;

  const router = useRouter();

  // if (isLoggedIn === undefined) {
  //   return null; // or <LoadingSpinner />
  // }

  // if (!isLoggedIn) {
  //   router.back();
  //   return null;
  // }

  const handleSearchChange = useCallback((newSearchTerm: string) => {
    setSearchTerm(newSearchTerm);
  }, []);

  const handleBackClick = async () => {
    const userDraftOrders = orderData?.userDraftOrders;

    if (userDraftOrders && Array.isArray(userDraftOrders)) {
      const fastBuyOrder = userDraftOrders.find(
        order => order?.isFastBuy === true
      );

      if (fastBuyOrder) {
        try {
          await orderDelete({ variables: { id: fastBuyOrder?.id } });
          router.back();
        } catch (error) {
          console.error('Ошибка при удалении черновика заказа:', error);
          router.back();
        }
      } else {
        router.back();
      }
    } else {
      router.back();
    }
  };
  const handleClickPaymentsTab = useCallback(() => {
    setActivePayment(true);
  }, []);

  const handleOpenProductsTab = () => {
    setOpenProducts(!openProducts);
  };
  const handleSelectTab = (id: number) => {
    setTab(id);
  };

  useEffect(() => {
    if (shippingId === null) {
      setActivePayment(false);
    } else if (!checked) {
      setActivePayment(false);
    }
  }, [checked, shippingId]);

  useEffect(() => {
    if (order?.shippingAddress) {
      setActivePayment(true);
    } else if (shippingDate === null) {
      setActivePayment(false);
    } else if (!checked) {
      setActivePayment(false);
    }
  }, [checked, shippingDate, orderData]);

  useEffect(() => {
    if (collectionPointId === null) {
      setActivePayment(false);
    }
  }, [tab]);

  useEffect(() => {
    setCollectionPointId(null);
  }, [tab]);

  useEffect(() => {
    if (order?.deliveryMethod?.__typename === 'Warehouse') {
      setTab(2);
      const targetWarehouseId = order?.deliveryMethod?.id;
      const warehouseEdges = warehousesData?.warehouses?.edges;
      const foundWarehouse = warehouseEdges?.find(
        edge => edge?.node?.id === targetWarehouseId
      );
      const foundId = foundWarehouse?.node?.id ?? null;
      setCollectionPointId(foundId);
    } else {
      setShippingId(order?.deliveryMethod?.id ?? null);
    }
  }, [order, warehousesData, tab]);

  const showSkeletons = !user || loading;

  const [addressFormData, setAddressFormData] = useState<Address | null>(null);

  const handleSetAddress = useCallback((addr: Address | null) => {
    setAddressFormData(addr);
  }, []);

  const handleSetSelectedPoint = useCallback((id: string | null) => {
    setCollectionPointId(id);
  }, []);

  const handleCheckedChange = useCallback((checked: boolean) => {
    setChecked(checked);
  }, []);

  const checkUzumUserStatus = async (phone: string) => {
    const formattedPhone = phone.startsWith('+') ? phone.slice(1) : phone;

    try {
      const response = await uzumNasiyaCheckStatus({
        variables: {
          phone: formattedPhone,
        },
      });

      const uzumCheckStatusResult =
        response?.data?.orderUzumNasiyaCheckStatus?.result;

      if (uzumCheckStatusResult) {
        const uzumCheckStatusData = uzumCheckStatusResult?.data;

        if (uzumCheckStatusData) {
          if (uzumCheckStatusResult.status === 'success') {
            setUzumWebViewUrl(uzumCheckStatusData?.webview);
            setUzumBuyerId(uzumCheckStatusData?.buyerId);
            if (
              uzumCheckStatusData?.status === 0 &&
              uzumCheckStatusData?.webview
            ) {
              window.open(uzumCheckStatusData.webview, '_blank');
            } else if (uzumCheckStatusData.status === 4) {
              console.log('Пользователь верифицирован в Uzum Nasiya');
            }
          } else {
            console.error(
              'Ошибка при проверке статуса пользователя Uzum:',
              uzumCheckStatusResult.error
            );
          }
        } else {
          toast.error('Ошибка: uzumCheckStatusResult.data is null');
        }
      } else {
        toast.error('Ошибка: orderUzumNasiyaCheckStatus.result is null');
      }
    } catch (error) {
      toast.error(`Ошибка при выполнении запроса к Uzum API: ${error}`);
    }
  };

  const handleCompleteOrder = async () => {
    if (!order) {
      toast.error('Нет данных о заказе для завершения.');
      return;
    }

    try {
      const updateResult = await updateDraftOrder({
        variables: {
          id: order?.id,
          input: {
            user: user?.id,
            paymentMethodName: paymentMethod,
            shippingAddress: {
              city: user?.cityName,
              name: addressFormData?.name,
              streetAddress: addressFormData?.streetAddress,
              houseNumber: addressFormData?.houseNumber,
              apartmentNumber: addressFormData?.apartmentNumber,
              houseSection: addressFormData?.houseSection,
              floor: addressFormData?.floor,
              doorCode: addressFormData?.doorCode,
              note: addressFormData?.note,
            },
            billingAddress: {
              city: user?.cityName,
              name: addressFormData?.name,
              streetAddress: addressFormData?.streetAddress,
              houseNumber: addressFormData?.houseNumber,
              apartmentNumber: addressFormData?.apartmentNumber,
              houseSection: addressFormData?.houseSection,
              floor: addressFormData?.floor,
              doorCode: addressFormData?.doorCode,
              note: addressFormData?.note,
            },
            ...(tab === 3 ? { shippingIsYandex: true } : {}),
            ...(tab === 1 || tab === 3
              ? { shippingMethod: shippingId }
              : { collectionPoint: collectionPointId }),
            ...(hasCities && (tab === 1 || tab === 3)
              ? {
                  shippingDate: shippingDate,
                  shippingStartTime: shippingStartTime,
                  shippingEndTime: shippingEndTime,
                }
              : {}),
            ...(paymentMethod === PaymentTabEnum.INSTALLMENT
              ? {
                  installmentPartnerName: installmentName.toString(),
                  installmentPeriod: installmentPeriod,
                }
              : {}),
          },
        },
      });

      if (updateResult.errors) {
        toast.error(
          `Ошибка при обновлении черновика заказа: ${updateResult.errors}`
        );
        return;
      }

      const updatedDraftOrder = updateResult.data?.draftOrderUpdate?.order;

      if (!updatedDraftOrder) {
        toast.error('Не удалось получить обновленные данные черновика заказа.');
        return;
      }

      if (paymentMethod) {
        if (paymentMethod === PaymentTabEnum.FREEDOM_PAY) {
          try {
            const orderFreedomRes = await orderFreedom({
              variables: {
                id: updatedDraftOrder?.id,
                amount: order?.total?.net?.amount,

                successUrl: `https://radius-store.devsymfony.io/success/${updatedDraftOrder?.id}`,
                failureUrl: `https://radius-store.devsymfony.io/success/${updatedDraftOrder?.id}`,
              },
            });

            if (orderFreedomRes.errors) {
              toast.error(
                `Ошибка при выполнении orderFreedom: ${orderFreedomRes.errors}`
              );
              return;
            }

            if (orderFreedomRes?.data?.orderFreedomPayInit?.redirectUrl) {
              window.location.href =
                orderFreedomRes.data.orderFreedomPayInit.redirectUrl;
            } else {
              toast.error('URL для перенаправления не получен.');
            }
          } catch (error) {
            toast.error(`Произошла ошибка при вызове orderFreedom: ${error}`);
          }
        } else if (paymentMethod === PaymentTabEnum.CLICK) {
          try {
            const orderClickRes = await orderClick({
              variables: {
                id: updatedDraftOrder?.id,
                amount: order?.total?.net?.amount,
                returnUrl: `https://radius-store.devsymfony.io/success/${updatedDraftOrder?.id}`,
              },
            });

            if (orderClickRes.errors) {
              console.error(
                'Ошибка при выполнении orderClick:',
                orderClickRes.errors
              );
              return;
            }

            if (orderClickRes?.data?.orderClickPaymentUrl?.redirectUrl) {
              window.location.href =
                orderClickRes.data.orderClickPaymentUrl.redirectUrl;
            } else {
              toast.error('URL для перенаправления не получен.');
            }
          } catch (error) {
            toast.error(`Произошла ошибка при вызове orderClick: ${error}`);
          }
        } else if (paymentMethod === PaymentTabEnum.CASH) {
          try {
            router.push(`/success/${updatedDraftOrder?.id}`);
            setState(false);
          } catch (error) {
            toast.error(`Ошибка при выполнении completeDraftOrder: ${error}`);
          }
        } else if (paymentMethod === PaymentTabEnum.PAYME) {
          const merchantId = process.env.NEXT_PUBLIC_PAYME_MERCHANT_ID;
          const orderId = updatedDraftOrder?.number;
          const amountInTiyin = order?.total?.net?.amount * 100;
          const callbackUrl = encodeURIComponent(window.location.origin);
          const language = 'ru'; // Язык

          let params = `m=${merchantId};`;
          params += `ac.order_number=${orderId};`;
          params += `a=${amountInTiyin};`;
          params += `c=https://radius-store.devsymfony.io/success/${updatedDraftOrder?.id}`;
          // params += `l=${language};`;
          // params += `c=${callbackUrl};`;

          const encodedParams = btoa(unescape(encodeURIComponent(params)));

          const paymeUrl = `${process.env.NEXT_PUBLIC_PAYME_URL}${encodedParams}`;

          window.location.href = paymeUrl;

          return;
        } else if (paymentMethod === PaymentTabEnum.UZUM_BANK) {
          const amountInTiyin = order?.total?.net?.amount * 100;
          const uzumbankUrl = process.env.NEXT_PUBLIC_UZUMBANK_URL;
          const serviceId = process.env.NEXT_PUBLIC_UZUMBANK_SERVICE_ID;

          const redirectUrl = `${uzumbankUrl}?serviceId=${serviceId}&amount=${amountInTiyin}`;

          window.location.href = redirectUrl;

          return;
        } else if (paymentMethod === PaymentTabEnum.INSTALLMENT) {
          if (installmentName === ExternalPartnerNameEnum.UZUM) {
            if (!user?.phone) {
              toast.error('Номер телефона пользователя не найден.');
              return;
            }

            try {
              await checkUzumUserStatus(user.phone);
            } catch (error) {
              toast.error(
                `Ошибка при проверке статуса пользователя Uzum: ${error}`
              );
            }
            return;
          } else if (
            installmentName === ExternalPartnerNameEnum.ALIF ||
            installmentName === 'RADIUS' ||
            installmentName === 'IMAN'
          ) {
            router.push(`/success/${updatedDraftOrder?.id}`);
            setState(false);
          } else if (installmentName === ExternalPartnerNameEnum.ALLGOOD) {
          }
        }
      } else {
        toast.error('Payment method is empty, skipping payment processing.');
      }

      // await completeDraftOrder({
      //     variables: {
      //         id: updatedDraftOrder?.id,
      //     },
      // })
    } catch (error) {
      toast.error(`Ошибка при оформлении заказа: ${error}`);
    }
  };
  const t = useTranslations('OrderPage');
  return (
    <div className={styles.orderWrapper}>
      <div className={styles.headerContainer}>
        <div className={styles.pageHeader}>
          <div className={styles.headerInfo}>
            <div
              className={styles.lineArrowLeftParent}
              onClick={handleBackClick}
            >
              <IconArrowLeft />
              <div className={styles.title}>{t('go-back')}</div>
            </div>
          </div>
          <div className={styles.headerLogotype}>
            <IconLogo />
          </div>
          <div className={styles.labelParent}>
            <div className={styles.label}>
              <CustomCitiesSelect
                style={{ width: '155px' }}
                getSelectedValue={value => setCity(value)}
              />
            </div>
            <div className={styles.logo}>+998 (71) 200 31 00</div>
          </div>
        </div>
        <div className={styles.mobileHeader}>
          <MobileHeader onClick={handleBackClick} />
        </div>
      </div>

      {state ? (
        <div className={styles.contentWrapper}>
          <h4 className={styles.title}>{t('formalization')}</h4>
          <div className={styles.formWrapper}>
            <div className={styles.formContainer}>
              <div className={styles.leftSide}>
                <div className={styles.leftSideContainer}>
                  <div className={styles.tabHeaderWrapper}>
                    <h4 className={styles.leftSideTitle}>
                      1.{t('method-take')}
                    </h4>
                    {user && (
                      <div className={styles.yourCity}>
                        {windowSize.width < 768 ? (
                          <>
                            <span>{t('your-city')}</span>
                            <CustomCitiesSelect
                              style={{ width: 'max-content' }}
                              getSelectedValue={value => setCity(value)}
                            />
                          </>
                        ) : (
                          <>
                            <span>{t('your-city')}</span>
                            <div className={styles.city}>{user?.cityName}</div>
                          </>
                        )}
                      </div>
                    )}
                    <div className={styles.tabs}>
                      <Button
                        type="button"
                        onClick={() => handleSelectTab(1)}
                        className={`${styles.tab} ${tab === 1 && styles.activeTab}`}
                      >
                        {t('delivery')}
                      </Button>
                      <Button
                        type="button"
                        onClick={() => handleSelectTab(2)}
                        disabled={isPickupDisabled}
                        className={`${styles.tab} ${
                          tab === 2 && styles.activeTab
                        } ${isPickupDisabled && styles.disabledTab}`}
                      >
                        {t('self-pickup')}
                      </Button>
                      <Button
                        type="button"
                        disabled={!deliveryIsYandex}
                        onClick={() => handleSelectTab(3)}
                        className={`${styles.tab} ${
                          tab === 3 && styles.activeTab
                        } ${!deliveryIsYandex && styles.disabledTab}`}
                      >
                        {t('yandex-delivery')}
                      </Button>
                    </div>
                  </div>
                  {tab === 1 && (
                    <DeliverySection
                      setAddressFormData={setAddressFormData}
                      shippingId={shippingId}
                      setShippingId={setShippingId}
                      orderData={orderData}
                      onCheckedChange={setChecked}
                      checked={checked}
                      onClickPaymentsTab={handleClickPaymentsTab}
                      setShippingDate={setShippingDate}
                      shippingDate={shippingDate}
                      setShippingStartTime={setShippingStartTime}
                      shippingStartTime={shippingStartTime}
                      setShippingEndTime={setShippingEndTime}
                      setHasCities={setHasCities}
                      hasCities={hasCities}
                      setDeliveryIsYandex={setDeliveryIsYandex}
                      setDeliveryPrice={setDeliveryPrice}
                    />
                  )}
                  {tab === 2 && (
                    <PickupSection
                      loading={warehousesLoading}
                      setAddressFormData={handleSetAddress}
                      selectedPickupPoint={collectionPointId}
                      setSelectedPickupPoint={handleSetSelectedPoint}
                      onCheckedChange={handleCheckedChange}
                      onClickPaymentsTab={handleClickPaymentsTab}
                      orderData={warehousesData}
                      onSearchChange={handleSearchChange}
                    />
                  )}
                  {tab === 3 && (
                    <YandexDeliverySection
                      setAddressFormData={setAddressFormData}
                      shippingId={shippingId}
                      setShippingId={setShippingId}
                      orderData={orderData}
                      onCheckedChange={setChecked}
                      checked={checked}
                      onClickPaymentsTab={handleClickPaymentsTab}
                      setShippingDate={setShippingDate}
                      shippingDate={shippingDate}
                      setShippingStartTime={setShippingStartTime}
                      shippingStartTime={shippingStartTime}
                      setShippingEndTime={setShippingEndTime}
                      setHasCities={setHasCities}
                      hasCities={hasCities}
                      setDeliveryPrice={setDeliveryPrice}
                    />
                  )}
                </div>
              </div>
              <div className={styles.paymentTypes}>
                <Accordion>
                  <Accordion.Panel
                    caretAs={IconBg}
                    expanded={activePayment}
                    header={
                      <div className={styles.paymentTypeTitle}>
                        2.{t('payment-method')}
                      </div>
                    }
                    defaultExpanded
                  >
                    <div>
                      <Payment
                        setInstallmentName={setInstallmentName}
                        setInstallmentPeriod={setInstallmentPeriod}
                        setPaymentMethod={setPaymentMethod}
                        setState={setState}
                        data={orderData}
                        onCompleteOrder={handleCompleteOrder}
                        setApplicationId={setApplicationId}
                        applicationId={applicationId}
                        loading={updateLoading}
                      />
                    </div>
                  </Accordion.Panel>
                </Accordion>
              </div>
            </div>
            <div className={styles.rightSide}>
              <div className={styles.totalPrice}>
                <div className={styles.totalPriceTitle}>{t('total')}</div>
                {showSkeletons ? (
                  <div className={styles.totalPriceTitle}>
                    <Skeleton
                      className={styles.skeleton}
                      width={125}
                      height={28}
                    />
                  </div>
                ) : (
                  <div className={styles.totalPriceTitle}>
                    {convertToReadable(order?.total?.net?.amount)} {t('price')}
                  </div>
                )}
              </div>

              {showSkeletons ? (
                <div className={styles.skeletonWrapper}>
                  <Skeleton
                    className={styles.skeleton}
                    width={85}
                    height={28}
                  />
                  <Skeleton
                    className={styles.skeleton}
                    width={105}
                    height={28}
                  />
                </div>
              ) : (
                order?.totalBonuses !== 0 && (
                  <div className={styles.bonus}>
                    <div className={styles.left}>
                      <span>{t('bonus')}</span>
                      <IconInfo />
                    </div>
                    <div className={styles.right}>
                      +{convertToReadable(order?.totalBonuses)} {t('price')}
                    </div>
                  </div>
                )
              )}
              <div className={styles.productsInfo}>
                {showSkeletons ? (
                  <div className={styles.skeletonWrapper}>
                    <Skeleton
                      className={styles.skeleton}
                      width={90}
                      height={20}
                    />
                    <Skeleton
                      className={styles.skeleton}
                      width={110}
                      height={20}
                    />
                  </div>
                ) : (
                  <CustomDefaultAccordion
                    title={`${order?.lines.length} ${t('item')}`}
                    price={convertToReadable(
                      order?.undiscountedTotal?.net?.amount
                    )}
                    isOpen={openProducts}
                    onClick={handleOpenProductsTab}
                  >
                    <div className={styles.cardsWrapper}>
                      {order?.lines
                        ?.filter((product: any) => product?.isGift === false)
                        .map((product: any) => {
                          return (
                            <div
                              key={product.productVariantId}
                              className={styles.card}
                            >
                              <div className={styles.cardWrapper}>
                                {product?.variant?.media?.[0]?.url && (
                                  <Image
                                    className={styles.productPhotoIcon}
                                    alt="productPhoto"
                                    src={
                                      product?.variant?.media?.[0]?.url
                                        ? product?.variant?.media?.[0]?.url
                                        : DefaultProductPlaceholder
                                    }
                                    width={42}
                                    height={42}
                                  />
                                )}
                                <div className={styles.productInfo}>
                                  <div className={styles.productTitle}>
                                    {product?.variantName}
                                  </div>
                                  <div className={styles.prices}>
                                    <div className={styles.left}>
                                      <div className={styles.price}>
                                        {convertToReadable(
                                          product?.variant?.pricing?.price?.net
                                            ?.amount
                                        )}{' '}
                                        {t('price')}
                                      </div>
                                      {product?.variant?.pricing
                                        ?.priceUndiscounted?.net?.amount !==
                                        product?.variant?.pricing?.price?.net
                                          ?.amount && (
                                        <div className={styles.oldPrice}>
                                          {convertToReadable(
                                            product?.variant?.pricing
                                              ?.priceUndiscounted?.net?.amount
                                          )}{' '}
                                          {t('price')}
                                        </div>
                                      )}
                                    </div>
                                    {product?.quantity > 1 && (
                                      <div className={styles.count}>
                                        {product?.quantity}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      {order?.lines
                        ?.filter(
                          (product: any) =>
                            product?.isGift === false &&
                            Array.isArray(product?.variant?.gifts) &&
                            product?.variant?.gifts.length > 0
                        )
                        .map((product: any) => {
                          return (
                            <div
                              key={product.productVariantId}
                              className={styles.card}
                            >
                              <h4 className={styles.header}>{t('set-gift')}</h4>
                              <div className={styles.cardWrapper}>
                                {product?.variant?.media?.[0]?.url && (
                                  <Image
                                    className={styles.productPhotoIcon}
                                    alt="productPhoto"
                                    src={
                                      product?.variant?.media?.[0]?.url
                                        ? product?.variant?.media?.[0]?.url
                                        : DefaultProductPlaceholder
                                    }
                                    width={42}
                                    height={42}
                                  />
                                )}
                                <div className={styles.productInfo}>
                                  <div className={styles.productTitle}>
                                    {product?.variantName}
                                  </div>
                                  <div className={styles.prices}>
                                    <div className={styles.left}>
                                      <div className={styles.price}>
                                        {convertToReadable(
                                          product?.variant?.pricing?.price?.net
                                            ?.amount
                                        )}{' '}
                                        {t('price')}
                                      </div>
                                      {product?.variant?.pricing
                                        ?.priceUndiscounted?.net?.amount !==
                                        product?.variant?.pricing?.price?.net
                                          ?.amount && (
                                        <div className={styles.oldPrice}>
                                          {convertToReadable(
                                            product?.variant?.pricing
                                              ?.priceUndiscounted?.net?.amount
                                          )}{' '}
                                          {t('price')}
                                        </div>
                                      )}
                                    </div>
                                    {product?.quantity > 1 && (
                                      <div className={styles.count}>
                                        {product?.quantity}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {product?.variant?.gifts?.map(
                                (giftProduct: any) => {
                                  return (
                                    <div
                                      className={styles.cardWrapper}
                                      key={giftProduct?.id}
                                    >
                                      {giftProduct?.media?.[0]?.url && (
                                        <Image
                                          className={styles.productPhotoIcon}
                                          alt="productPhoto"
                                          src={
                                            giftProduct?.media?.[0]?.url
                                              ? giftProduct?.media?.[0]?.url
                                              : DefaultProductPlaceholder
                                          }
                                          width={42}
                                          height={42}
                                        />
                                      )}
                                      <div className={styles.productInfo}>
                                        <p className={styles.productTitle}>
                                          {giftProduct?.name}
                                        </p>
                                        <div className={styles.prices}>
                                          <div className={styles.left}>
                                            <div className={styles.price}>
                                              {t('gift')}
                                            </div>
                                            <div className={styles.oldPrice}>
                                              {
                                                giftProduct?.pricing
                                                  ?.priceUndiscounted?.net
                                                  ?.amount
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          );
                        })}
                    </div>
                  </CustomDefaultAccordion>
                )}
              </div>
              {showSkeletons ? (
                <div className={styles.skeletonWrapper}>
                  <Skeleton
                    className={styles.skeleton}
                    width={90}
                    height={20}
                  />
                  <Skeleton
                    className={styles.skeleton}
                    width={110}
                    height={20}
                  />
                </div>
              ) : (
                order?.totalBenefit?.amount !== 0 && (
                  <CustomDefaultAccordion
                    title={t('benefit')}
                    price={`-${convertToReadable(order?.totalBenefit?.amount)}`}
                    isOpen={openProducts2}
                    onClick={() => setOpenProducts2(!openProducts2)}
                  >
                    <div className={styles.benefits}>
                      <div className={styles.item}>
                        <div className={styles.titleBenefits}>
                          {t('discount')}
                        </div>
                        <div className={styles.description}>
                          {`-${convertToReadable(order?.discountBenefit?.amount)}`}{' '}
                          {t('price')}
                        </div>
                      </div>
                      {order?.giftsPrice?.amount !== 0 && (
                        <div className={styles.item}>
                          <div className={styles.titleBenefits}>
                            {t('gift')}
                          </div>
                          <div className={styles.description}>
                            {`-${convertToReadable(order?.giftsPrice?.amount)}`}{' '}
                            {t('price')}
                          </div>
                        </div>
                      )}
                    </div>
                  </CustomDefaultAccordion>
                )
              )}
              {tab !== 2 && (
                <div className={styles.bottom}>
                  <div className={styles.item}>
                    <div className={styles.titleBenefits}>{t('delivery')}</div>
                    <div className={styles.description}>
                      {order?.deliveryMethod
                        ? order?.deliveryMethod?.__typename ===
                          'CityShippingMethod'
                          ? order?.shippingPrice?.net?.amount === 0
                            ? t('free')
                            : `от ${convertToReadable(order?.shippingPrice?.net?.amount)} ${t('price')}`
                          : order?.deliveryMethod?.name
                        : tab === 1
                          ? deliveryPrice === 0
                            ? t('free')
                            : `от ${convertToReadable(deliveryPrice)} ${t('price')}`
                          : deliveryPrice === 0
                            ? t('free')
                            : `от ${convertToReadable(deliveryPrice)} ${t('price')}`}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        // <OrderFinish />
        // isOrderComplete && <OrderFinish orderCompleteRes={orderCompleteRes} />
        <></>
      )}
    </div>
  );
};

export default OrderPageContent;
